import React, { useEffect, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { AnalyticsEvent } from "../../components/elements/analytics-event";
import { Poll1v1 } from "../ui";
import { PollName } from "../elements";

const PollOverlay = (props) => {
  const startId = useRef(0);
  const endId = useRef(0);

  const end = () => {
    ["poll_name"].forEach(function (ids) {
      document.getElementById(ids).classList.add("deactive");
      document.getElementById(ids).classList.remove("active");
    });
  };

  const setActive = () => {
    ["poll_name"].forEach((ids) => {
      document.getElementById(ids).classList.add("active");
      document.getElementById(ids).classList.remove("deactive");
      endId.current = setTimeout(end, 10000);
    });
  };

  useEffect(() => {
    const url = `${process.env.REACT_APP_LOCAL_URI}/polls-1v1/`;

    let pollURL = window.location.href.replace(url, "").split("/");
    let pollID = pollURL[0] ? pollURL[0] : 3809;

    props.pollStore.socketConnect(pollID);
    startId.current = setInterval(setActive, 300000);

    return () => {
      clearInterval(startId.current);
      clearTimeout(endId.current);
    };
  }, []);

  const { name } = props.pollStore;

  return (
    <div className="poll-1v1-wrapper">
      {AnalyticsEvent("english", "/", "PLAY LIVE Poll 1v1 Overlay")}
      <PollName>
        <p>Poll: {name}</p>
      </PollName>
      <Poll1v1 />
    </div>
  );
};

export default inject("pollStore")(observer(PollOverlay));
